import { SvgIcon, type SvgIconProps } from './svgIcon'

export function ProfileIcon({
  width = 22,
  height = 22,
  ...props
}: SvgIconProps) {
  return (
    <SvgIcon
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      {...props}>
      <path
        d="M19.08 16.8699C19.14 16.7899 19.2 16.6999 19.26 16.6199C20.35 15.0199 20.99 13.0899 20.99 10.9999C20.99 5.46994 16.52 0.999939 10.99 0.999939C5.46002 0.999939 0.990017 5.46994 1.00002 10.9899C1.00002 13.2499 1.74002 15.3199 3.00002 16.9999C3.06002 17.0799 3.11002 17.1499 3.17002 17.2199C5.00002 19.5199 7.68002 20.9999 11 20.9999C14.32 20.9999 17.26 19.3699 19.08 16.8699ZM19.08 16.8699C17.97 13.5599 14.99 11.1799 11.17 11.1799C7.35002 11.1799 4.15002 13.7299 3.16002 17.2199M14.32 7.83994C14.32 9.67905 12.8291 11.1699 10.99 11.1699C9.15091 11.1699 7.66002 9.67905 7.66002 7.83994C7.66002 6.00083 9.15091 4.50994 10.99 4.50994C12.8291 4.50994 14.32 6.00083 14.32 7.83994Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
    </SvgIcon>
  )
}
